import AnythingGoesFull from "./assets/audio/AnythingGoes/Anything Goes_Full.mp3";
import AnythingGoesCountdown from './assets/audio/AnythingGoes/AnythingGoesCountdown4Real.mp3';
import AnythingGoesPart1 from './assets/audio/AnythingGoes/Anything Goes_Part1.mp3';
import AnythingGoesPart2 from './assets/audio/AnythingGoes/Anything Goes_Part2.mp3';
import AnythingGoesPart3 from './assets/audio/AnythingGoes/Anything Goes_Part3.mp3';
import AnythingGoesPart4 from './assets/audio/AnythingGoes/Anything Goes_Part4.mp3';
import AnythingGoesImage1 from "./assets/images/facts/anything-goes-1.jpg";
import AnythingGoesImage2 from "./assets/images/facts/anything-goes-2.jpg";
import AnythingGoesImage3 from "./assets/images/facts/anything-goes-3.jpg";

import ChorusLineFull from "./assets/audio/Chorus/ChorusFull.mp3";
import ChorusLineCountdown from './assets/audio/Chorus/ChorusCountdown4Real.mp3';
import ChorusLinePart1 from './assets/audio/Chorus/ChorusPart1.mp3';
import ChorusLinePart2 from './assets/audio/Chorus/ChorusPart2.mp3';
import ChorusLinePart3 from './assets/audio/Chorus/ChorusPart3.mp3';
import ChorusLinePart4 from './assets/audio/Chorus/ChorusPart4.mp3';
import ChorusLineImage1 from "./assets/images/facts/chorus-line-1.jpg";
import ChorusLineImage2 from "./assets/images/facts/chorus-line-2.jpg";
import ChorusLineImage3 from "./assets/images/facts/chorus-line-3.jpg";

import FreeStyleFull from "./assets/audio/FreeStyle/FreeStyle_Full.mp3";
import FreeStyleCountdown from './assets/audio/FreeStyle/FreeStyleCountdown4Real.mp3';
import FreeStylePart1 from './assets/audio/FreeStyle/FreeStylePart1.mp3';
import FreeStylePart2 from './assets/audio/FreeStyle/FreeStylePart2.mp3';
import FreeStylePart3 from './assets/audio/FreeStyle/FreeStylePart3.mp3';
import FreeStylePart4 from './assets/audio/FreeStyle/FreeStylePart4.mp3';
import FreeStyleImage1 from "./assets/images/facts/free-style-1.jpg";
import FreeStyleImage2 from "./assets/images/facts/free-style-2.jpg";
import FreeStyleImage3 from "./assets/images/facts/free-style-3.jpg";

import GoodMorningFull from "./assets/audio/GoodMorning/GoodMorning_Full.mp3";
import GoodMorningCountdown from './assets/audio/GoodMorning/GoodMorningCountdown4Real.mp3';
import GoodMorningPart1 from './assets/audio/GoodMorning/GoodMorning_Part1.mp3';
import GoodMorningPart2 from './assets/audio/GoodMorning/GoodMorning_Part2.mp3';
import GoodMorningPart3 from './assets/audio/GoodMorning/GoodMorning_Part3.mp3';
import GoodMorningPart4 from './assets/audio/GoodMorning/GoodMorning_Part4.mp3';
import GoodMorningImage1 from "./assets/images/facts/good-morning-1.jpg";
import GoodMorningImage2 from "./assets/images/facts/good-morning-2.jpg";
import GoodMorningImage3 from "./assets/images/facts/good-morning-3.jpg";

import MosesSupposesFull from "./assets/audio/Moses/MosesFull.mp3";
import MosesSupposesCountdown from './assets/audio/Moses/MosesCountdown4Real.mp3';
import MosesSupposesPart1 from './assets/audio/Moses/MosesPart1.mp3';
import MosesSupposesPart2 from './assets/audio/Moses/MosesPart2.mp3';
import MosesSupposesPart3 from './assets/audio/Moses/MosesPart3.mp3';
import MosesSupposesPart4 from './assets/audio/Moses/MosesPart4.mp3';
import MosesSupposesImage1 from "./assets/images/facts/moses-supposes-1.jpg";
import MosesSupposesImage2 from "./assets/images/facts/moses-supposes-2.jpg";
import MosesSupposesImage3 from "./assets/images/facts/moses-supposes-3.jpg";


export const TESTING_MODE = false;

export const DATA = {
    songs: [
        {
            name: "Anything Goes",
            id: 0,
            production: "Anything Goes",
            description: "“Anything Goes” is the title number from the famous 1934 musical about a comedic love story aboard the S.S. American.",
            mediaURLFull: AnythingGoesFull,
            mediaURLCountdown: AnythingGoesCountdown,
            facts: [
                {
                    imageURL: AnythingGoesImage1,
                    text: "In the musical’s title song, <b>one of the original lines included,</b> “Good authors too who once knew better words / Now only use four-letter words.”<br><br>When turned into a film, the line was changed to “Now only use three-letter words,” to avoid implications of obscenity.",
                    altText: "This is alt text!",
                    copyright: "Watch Anything Goes on TCM in June",
                },
                {
                    imageURL: AnythingGoesImage2,
                    text: "“Anything Goes” storyline was <b>originally about a shipwreck,</b> but a few weeks before the musical’s opening, the SS Morro Castle caught fire and 138 passengers lost their lives.<br><br> To avoid releasing the musical with the potential of backlash and seeming insensitive, the script was quickly altered to portray a comedic and charming storyline.",
                    altText: "This is alt text!",
                    copyright: "Watch Anything Goes on TCM in June",
                },
                {
                    imageURL: AnythingGoesImage3,
                    text: "From 1934 to 2011, the script changed numerous times to avoid offending the audience. Insensitive, ethnic humor is included in the older version of the script where <b>two Chinese passengers (Ching and Ling)</b> are shown to speak broken English and lack character depth.<br><br> In 2011, Ching and Ling were replaced with two characters, Luke and John.",
                    altText: "This is alt text!",
                    copyright: "Watch Anything Goes on TCM in June",
                }
            ],
            questions: [
                {
                    question: "In the musical, which character performs the song “Anything Goes?”",
                    answers: [
                        "Billy",
                        "Reno",
                        "Evelyn",
                        "Bonnie"
                    ],
                    correctIndex: 1,
                    funFact: "The character, Reno, is meant to portray a parody of Aimee Semple McPherson. McPherson was known as a Pentecostal evangelist and media celebrity in the 1920s and 1930s."
                },
                {
                    question: "Where was the musical “Anything Goes” first performed in 1934?",
                    answers: [
                        "Gerald Schoenfeld Theater",
                        "Alvin Theater",
                        "Broadhurst Theater",
                        "Hayes Theater"
                    ],
                    correctIndex: 1,
                    funFact: "Did you know: The musical ran for 420 performances, making it the fourth longest-running musical of the 1930s."
                },
                {
                    question: "Who is the composer of the musical “Anything Goes?”",
                    answers: [
                        "Robert Alton",
                        "Howard Lindsay",
                        "Russel Crouse",
                        "Cole Porter"
                    ],
                    correctIndex: 3,
                    funFact: "In 1937, Porter got into a major horse accident and was advised by the doctor to get both legs amputated. He refused, even though he would never be able to have full use of his legs again. To escape his pain, he composed the score of his Broadway musical, “Leave it to Me.”"
                }
            ],
            puzzleClips: {
                media: [
                    AnythingGoesPart1,
                    AnythingGoesPart4,
                    AnythingGoesPart3,
                    AnythingGoesPart2
                ],
                correctOrder: [0,3,2,1]
            },
            tapTimingsLeft: [5449, 5589, 5829, 5972, 6248, 6373, 6604, 6747, 6978, 7103, 7362, 7477, 7709, 7851, 8056, 8217, 8448, 8582, 8778, 8903, 9170, 9286, 9517, 9633, 9883, 10007, 10230, 10346, 10586, 10711, 10934, 11067, 11388, 11771, 12003, 12136, 12252, 12341, 12484, 12840, 13036, 13170, 13294, 13348, 13499, 13686, 13856, 14061, 14230, 14591, 14822, 15133, 15323, 15634, 15821, 16124, 16294, 16650, 16971, 17211, 17336, 17443, 17550, 17701, 17924, 18048, 18271, 18396, 18636, 18752, 18868, 18993, 19100, 19313, 19447, 19670, 19803, 20017, 20178, 20400, 20623, 20810, 20970, 21193, 21567, 21728, 22093, 22440, 22825, 23200, 23387, 23729, 23883, 24210, 24418, 24726, 24880, 25220, 25572, 25660, 25759, 25888, 25988, 26075, 26229, 26333, 26453, 26557, 26669, 26732, 26885, 26998, 27116, 27218, 27326, 27521, 27842, 28177],
            tapTimingsRight: [10,20,30,40,50,60,70,80,90,100]
        },
        {
            name: "A Chorus Line",
            id: 1,
            production: "A Chorus Line",
            description: "“A Chorus Line” is the title number from the sixth longest-running Broadway show ever, centered around seventeen dancers who are auditioning for spots on a chorus line.",
            mediaURLFull: ChorusLineFull,
            mediaURLCountdown: ChorusLineCountdown,
            facts: [
                {
                    imageURL: ChorusLineImage1,
                    text: "Many of the dancers in the opening scene <b>played two different characters.</b> One that gets cut quickly and then another who makes it into the first big group number. This is a cost-effective way of making it look like there are more dancers than there really are.",
                    altText: "This is alt text!",
                    copyright: "Watch A Chorus Line on TCM in June",
                },
                {
                    imageURL: ChorusLineImage2,
                    text: "<b>Audrey Landers</b> was generally not shown in wide shots of the entire cast dancing scenes due to her lack of experience. She is inserted in to close-up shots, and a dance double is clearly seen in long shots of the song “One.”",
                    altText: "This is alt text!",
                    copyright: "Watch A Chorus Line on TCM in June",
                },
                {
                    imageURL: ChorusLineImage3,
                    text: "The song <b>“Dance 10, Looks 3”</b> was originally given a far more obscene title. It was changed so that the audience would not have to see that title listed in their programs. The logic was that if it were a surprise during the show, it would cause a better audience reaction.",
                    altText: "This is alt text!",
                    copyright: "Watch A Chorus Line on TCM in June",
                }
            ],
            questions: [
                {
                    question: "How many Tony Awards has the musical “A Chorus Line” won?",
                    answers: [
                      "5 Tony Awards",
                      "3 Tony Awards",
                      "9 Tony Awards",
                      "15 Tony Awards"
                    ],
                    correctIndex: 2,
                    funFact: "Did you know: The Tony Awards began in 1947. Tickets were only $7 and anyone could attend."
                },
				{
                    question: "What year did “A Chorus Line” open?",
                    answers: [
                        "1946",
                        "1975",
                        "1982",
                        "1930"
                    ],
                    correctIndex: 1,
                    funFact: "Did you know: In 1975, the minimum wage in the United States was $2.10 per hour"
                },
				{
                    question: "How many times does each cast member kick his or her leg in the final kick line of the show?",
                    answers: [
                        "36 times (18 each leg)",
                        "20 times (10 each leg)",
                        "8 times (4 each leg)",
                        "16 times (8 each leg)"
                    ],
                    correctIndex: 0,
                    funFact: "Did you know: Toward the end of the finale, there is a deliberate mistake when one of the dancers in the second row falls down and gets right back up."
				}
            ],
            puzzleClips: {
                media: [
                    ChorusLinePart4,
                    ChorusLinePart3,
                    ChorusLinePart2,
                    ChorusLinePart1
                ],
                correctOrder: [3,2,1,0]
            },
            tapTimingsLeft: [5119, 5258, 5515, 5678, 6122, 6378, 6530, 6973, 7381, 7673, 7801, 8057, 8186, 8454, 8594, 8979, 9107, 9400, 9517, 9773, 9913, 10158, 10543, 10939, 11616, 11767, 12164, 12281, 12572, 12957, 13354, 13727, 13937, 14147, 14380, 14543, 14788, 14928, 15173, 15313, 15546, 15698, 15943, 16106, 16351, 16514, 16889, 17157, 17308, 17588, 17705, 18067, 18463, 18661, 18860, 19058, 19443, 19641, 19909, 20049, 20294, 20434, 20679, 20819, 21029, 21180, 21449, 21589, 21833, 21997, 22218, 22370, 22626, 22778, 23151, 23408, 23548, 23711, 23968, 24364, 24632, 24784, 25006, 25177, 25403, 26208, 26360, 26616, 26744, 26978, 27153, 27537, 27794, 27934, 28202, 28354, 28599, 28774, 29018, 29170, 29403, 29578, 29928, 30581, 30756],
            tapTimingsRight: [10,20,30,40,50,60,70,80,90,100]
        },
        {
            name: "Free Style",
            id: 2,
            production: "Kelsey Krigas",
            description: "This song is a freestyle tap number performed by Kelsey Krigas, who is studying theatre at Ball State University.",
            mediaURLFull: FreeStyleFull,
            mediaURLCountdown: FreeStyleCountdown,
            facts: [
                {
                    imageURL: FreeStyleImage1,
                    text: "The soles of early tap shoes were made out of wood. Tap dancing without metal soles is called <b>“soft-shoe dancing soles.”</b> Eventually, pennies or nails were hammered into the toe and heels of the tap shoes to create the tapping sound. Finally, tap shoes evolved once more when metal was used to manufacture them.",
                    altText: "This is alt text!",
                    copyright: "All Rights Reserved TCM",
                },
                {
                    imageURL: FreeStyleImage2,
                    text: "Tap dancing enhances both music and dancing skills. Learning the rhythm of the dances improves the ability to understand musical techniques, while the fast paced foot movements improves dancing techniques.",
                    altText: "This is alt text!",
                    copyright: "All Rights Reserved TCM",
                },
                {
                    imageURL: FreeStyleImage3,
                    text: "Between 1934 to 1940, <b>Shirley Temple</b> at just six years old appeared in 24 films and significantly increased the popularity of tap dancing. <b>Despite the Great Depression,</b> enrollment at tap dance schools shot up throughout the country.",
                    altText: "This is alt text!",
                    copyright: "All Rights Reserved TCM",
                }
            ],
            questions: [
                {
                    question: "When is National Tap Day?",
                    answers: [
                        "December 14",
                        "October 7",
                        "May 25",
                        "April 1"
                    ],
                    correctIndex: 2,
                    funFact: "Did you know: National Tap Day officially began in 1989 to celebrate the genre of tap dance. Bill “Bojangles” Robinson is a significant contributor to tap dance, so the date was chosen to recognize his birthday."
                },
				{
                    question: "What other form of dance does tap dancing share strong roots with?",
                    answers: [
                        "Irish Clogging",
                        "Salsa",
                        "Ballet",
                        "Jazz"
                    ],
                    correctIndex: 0,
                    funFact: "Did you know: One of the theories behind why the dancers keep their arms straight down at their sides is because the Catholic church disapproved of Irish dancing. This way, if a priest passed by a window of a house, he would not realize that they were dancing."
				},
				{
                    question: "Which tap dancer is known for their performances in “Singin’ in the Rain?”",
                    answers: [
                        "Gene Kelly",
                        "Fred Astaire",
                        "Gregory Hines",
                        "Shirley Temple"
                    ],
                    correctIndex: 0,
                    funFact: "Gene Kelly was innovative and invented the “the Ubangi,” now called a “camera off-set,” which is a device that allows for low-angle shots. He used this device for his fantasy film, The “Pirate“."
				}
            ],
            puzzleClips: {
                media: [
                    FreeStylePart2,
                    FreeStylePart4,
                    FreeStylePart3,
                    FreeStylePart1
                ],
                correctOrder: [3,0,2,1]
            },
            tapTimingsLeft: [5164, 5296, 5425, 5469, 5599, 5783, 5939, 6102, 6270, 6424, 6600, 6782, 7092, 7277, 7442, 7608, 7787, 7913, 8022, 8134, 8249, 8445, 8593, 8747, 8941, 9095, 9266, 9429, 9577, 9734, 9925, 10097, 10273, 10479, 10698, 10911, 11120, 11293, 11477, 11665, 11828, 12003, 12139, 12321, 12462, 12635, 12817, 12977, 13153, 13319, 13464, 13657, 13817, 14039, 14181, 14322, 14526, 14643, 14818, 15074, 15228, 15327, 15401, 15518, 15795, 15899, 16001, 16143, 16284, 16448, 16577, 16716, 16971, 17107, 17363, 17486, 17763, 17880, 18040, 18151, 18293, 18444, 18774, 19093, 19179, 19260, 19370, 19651, 19910, 20057, 20221, 20492, 20630, 20932, 21030, 21199, 21332, 21622, 21732, 22025, 22318, 22398, 22724, 23002, 23328, 23673, 23830, 24166, 24545, 24839],
            tapTimingsRight: [10,20,30,40,50,60,70,80,90,100]
        },
        {
            name: "Good Morning",
            id: 3,
            production: "Singin' in the Rain",
            description: "“Good Morning” is a number from the film musical “Singin’ in the Rain,” a romance and musical about the introduction of “talkies,” and how they transformed the film world.",
            mediaURLFull: GoodMorningFull,
            mediaURLCountdown: GoodMorningCountdown,
            facts: [
                {
                    imageURL: GoodMorningImage1,
                    text: "<b>Gene Kelly</b> choreographed his dance scenes with <b>Cyd Charisse</b> to hide the fact that she was taller than him. To make this work, they never stood upright when they were next to each other.",
                    altText: "This is alt text!",
                    copyright: "Watch Singin' in the Rain on TCM in June",
                },
                {
                    imageURL: GoodMorningImage2,
					text: "Studio technicians had to cover <b>two outdoor city blocks</b> with a tarp in order to make it appear dark and film the night scene for the title number. Overhead sprays were also installed for the song to be performed.",
                    altText: "This is alt text!",
                    copyright: "Watch Singin' in the Rain on TCM in June",
                },
                {
                    imageURL: GoodMorningImage3,
                    text: "<b>Debbie Reynolds</b> had to rub her eyes with onions to make herself cry for the penultimate scene. Before landing her role in “Singin’ in the Rain,” Reynolds had no dancing experience and had <b>three months</b> to learn what Gene Kelly and Donald O’Connor had been doing for years.",
                    altText: "This is alt text!",
                    copyright: "Watch Singin' in the Rain on TCM in June",
                }
            ],
            questions: [
                {
                    question: "“Good Morning” is actually a reworking of the song “This is the Missus” from which 1931 musical?",
                    answers: [
                        "“Scandals”",
                        "“The Wizard of Oz”",
                        "“Swing Time”",
                        "“Show Boat”"
                    ],
                    correctIndex: 0,
                    funFact: "Did you know: Singin’ in the Rain is the first of many jukebox musicals; a term used to describe musical films or plays that feature songs of other previous popular music acts."
                },
				 {
                    question: "The last shot of the number “Good Morning” of Don, Kathy, and Cosmo falling over the couch was so difficult it took ______ times to shoot it.",
                    answers: [
                        "40",
                        "15",
                        "37",
                        "13"
                    ],
                    correctIndex: 0,
                    funFact: "Did you know: The number “Good Morning” was so physically taxing to tap Debbie Reynolds was carried to her dressing room afterwards due to bursting blood vessels in her feet. Despite Reynold’s work, Gene Kelly still dubbed the sound of her feet in the final production."
				},
				 {
                    question: "Leading into the song “Good Morning,” Don exclaims that it was his “lucky day!” What was the date?",
                    answers: [
                        "March 24",
                        "October 22",
                        "February 23",
                        "April 25"
                    ],
                    correctIndex: 0,
                    funFact: "Did you know: Prior to Singin in the Rain, Debbie Reynolds was not a dancer. Years later she remarked that childbirth and the creation of Singin’ in the Rain were the two hardest things she had done in her life."
                }
            ],
            puzzleClips: {
                media: [
                    GoodMorningPart3,
                    GoodMorningPart2,
                    GoodMorningPart4,
                    GoodMorningPart1
                ],
                correctOrder: [3,1,0,2]
            },
            tapTimingsLeft: [5175, 5459, 5614, 5746, 5996, 6119, 6232, 6374, 6482, 6718, 7016, 7184, 7316, 7448, 7547, 7679, 7915, 8156, 8393, 8655, 8801, 8919, 9018, 9174, 9405, 9669, 9806, 9938, 9990, 10193, 10316, 10434, 10547, 10688, 10816, 10915, 11057, 11179, 11307, 11415, 11538, 11675, 11890, 12051, 12159, 12424, 12688, 12957, 13193, 13485, 13735, 14018, 14264, 14533, 14603, 14703, 14839, 14957, 15066, 15253, 15381, 15499, 15593, 15702, 15843, 16117, 16263, 16537, 16678, 16938, 17079, 17221, 17471, 17594, 17702, 17853, 17976, 18235, 18499, 18772],
            tapTimingsRight: [10,20,30,40,50,60,70,80,90,100]
        },
        {
            name: "Moses Supposes",
            id: 4,
            production: "Singin' in the Rain",
            description: "“Moses Supposes” is a duet between Gene Kelly and Donald O’Connor from the 1952 musical film “Singin’ in the Rain.”",
            mediaURLFull: MosesSupposesFull,
            mediaURLCountdown: MosesSupposesCountdown,
            facts: [
                {
                    imageURL: MosesSupposesImage1,
                    text: "Prior to developing a script, <b>Arthur Freed</b> compiled a list of songs from previous musicals that would be included in the film production.The script for the movie was then written after the songs, forcing writers <b>Adolph Green and Betty Comden</b> to create a plot in which the songs would fit.",
                    altText: "This is alt text!",
                    copyright: "Watch Singin' in the Rain on TCM in June",
                },
                {
                    imageURL: MosesSupposesImage2,
					text: "<b>Gene Kelly</b> directed, choreographed, and starred in “Singin’ in the Rain.” During the title number, <b>he was running a 103 degree fever</b> and would take breaks to lay out in the heat to “bake out the fever.”",
                    altText: "This is alt text!",
                    copyright: "Watch Singin' in the Rain on TCM in June",
                },
                {
                    imageURL: MosesSupposesImage3,
                    text: "<b>Cyd Charisse</b> was one of the dancers Gene Kelly hired to relieve an untrained Debbie Reynolds from too many dancing numbers. She had to be taught how to smoke a cigarette for the <b>“Broadway Ballet”</b> scene. Later, Charisse stated that she never smoked a cigarette after that.",
                    altText: "This is alt text!",
                    copyright: "Watch Singin' in the Rain on TCM in June",
                }
            ],
            questions: [
                {
                    question: "“Singin’ in the Rain” was a jukebox musical before the term jukebox musical existed. This means, most of the numbers were adopted from older musicals. Unlike all other numbers in the film,  “Moses Supposes” and ______ were the only two songs that were originally written for the Singin’ in the Rain film.",
                    answers: [
                        "“Make ‘Em Laugh”",
                        "“The Broadway Ballet”",
                        "“You Are My Lucky Star”",
                        "“Fit As A Fiddle”"
                    ],
                    correctIndex: 0,
                    funFact: "Did you know: “Make ‘Em Laugh” is a plagiarization of the song “Be A Clown”, a song written by Cole Porter for the musical “The Pirate“. Although Porter could have sued “Make ‘Em Laugh” creators Arthur Free and Nacio Herb Brown, he owed personal debt to Arthur Freed and chose not to sue."
                },
				{
                    question: "Where are characters Cosmo and Don During the number “Moses Supposes?”",
                    answers: [
                        "Out in the street",
                        "In Don’s home ",
                        "In a speech therapist’s office",
                        "At an audition"
                    ],
                    correctIndex: 2,
                    funFact: "Did you know: Although Gene Kelly (Don Lockwood) and Donald O’Connor (Cosmo) are close friends in “Singin’ in the Rain,” O’Connor later reflected that he, at first, did not enjoy working with Kelly, describing him as a tyrant."
				},
				{
					question: "During the time of its production, the number “Moses Supposes” is notable for:",
					answers: [
						"The scene when Don expresses his love for Kathy",
						"Becoming the first dancing trio between two men and a woman",
						"Debbie Reynolds’ first-ever singing debut ",
						"Physically-demanding dancing"
					],
					correctIndex: 3,
					funFact: "Several numbers of the film were shot on concrete floors. Tapping on concrete floors caused Donald O’Connor so much joint pain he had to take three days off after filming “Make ‘Em Laugh.”"
				}
            ],
            puzzleClips: {
                media: [
                    MosesSupposesPart4,
                    MosesSupposesPart1,
                    MosesSupposesPart2,
                    MosesSupposesPart3
                ],
                correctOrder: [1,2,3,0]
            },
            tapTimingsLeft: [5205, 5760, 6135, 6252, 6394, 6508, 6665, 6907, 7035, 7171, 7292, 7413, 7669, 7790, 7933, 8054, 8189, 8439, 8574, 8702, 8816, 8938, 9202, 9316, 9444, 9579, 9715, 9978, 10092, 10206, 10335, 10448, 10698, 11025, 11154, 11374, 11524, 11738, 11887, 12094, 12393, 12500, 12628, 12820, 13006, 13177, 13326, 13497, 13668, 14005, 14174, 14366, 14523, 15021, 15171, 15520, 15662, 15997, 16296, 16496, 16553, 16624, 16709, 16973, 17080, 17180, 17329, 17450, 17571, 17671, 17821, 18178, 18783, 19218, 19595, 19688, 19781, 19945, 20051, 20187, 20315, 20422, 20521, 20671, 20778, 20885, 21041, 21220, 21383, 21554, 21754, 21918, 22103, 22316, 22459, 22688, 22795, 23051, 23158, 23265, 23408, 23522, 23863, 24241, 24476, 24611, 24989, 25224, 25338, 25580, 25715, 25943, 26071, 26314, 26421, 26556, 26670, 26805, 27104, 27781, 27909, 28123, 28230, 28422, 28479, 28543, 28629, 28885, 28970, 29092, 29248, 29348, 30053, 30295, 30424, 30780, 31102, 31493, 31614, 31728, 31871, 32241, 32362, 32476, 32640, 33018, 33381, 33737, 33979, 34129, 34463, 34848, 35204, 35340, 35546, 35667, 35917, 36280, 36394, 36643, 36764, 36907, 37013, 37298, 37398, 37932, 38082, 38331, 38481, 38638, 38766, 38852, 39123, 39229, 39358, 39486, 39621, 39742, 39885, 40013, 40262, 40426],
            tapTimingsRight: [10,20,30,40,50,60,70,80,90,100]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/config.js